export const language: any = {
  title: "Komunitas Hey! Cooker",
  follow: "Ikuti",
  follower: "Pengikut",
  post_share: "Postingan bersama",
  like_share: "Suka",
  report: "Laporkan pelanggaran",
  delete_post: "Hapus postingan",
  delete_comment: "Hapus komentar",
  confirm_report: "Apakah Anda yakin postingan ini berisi konten yang melanggar pedoman komunitas? Setelah laporan berhasil, Anda tidak akan melihat postingan ini lagi.",
  confirm_report_comment: "Apakah Anda yakin komentar ini melanggar pedoman komunitas?",
  toats_report: "Terima kasih telah melaporkan pelanggaran, laporan Anda sedang ditinjau.",
  confirm_delete: "Apakah Anda ingin menghapus postingan ini?",
  confirm_delete_comment: "Apakah Anda yakin ingin menghapus komentar ini?",
  toast_delete: "Berhasil dihapus!",
  text_yes: "Ya",
  text_no: "Tidak",
  create: {
    title: "Buat Postingan - Komunitas Hey!Cooker",
    content_placeholder: "Masukkan konten postingan Anda",
    submit: "Bagikan Sekarang",
    add_image_by_camera: "Ambil foto",
    add_image_by_gallery: "Pilih gambar",
    add_video_by_camera: "Rekam video",
    add_video_by_gallery: "Pilih video",
  },
  detail: {
    shared: "Telah dibagikan",
    shared_community: "Telah membagikan foto (video) ke komunitas"
  },
  follwed: "Mengikuti",
  comment: {
    placeholder: "Silakan masukkan komentar",
    submit: "Kirim",
    nodata: "Tinggalkan komentar di sini dan jadilah yang pertama berkomentar!",
    load_more: "Lihat lebih banyak komentar",
    not_login: "Silakan masuk untuk berkomentar",
    delete: "Hapus komentar",
    delete_confirm: "Apakah Anda yakin ingin menghapus komentar ini?",
    delete_success: "Komentar berhasil dihapus",
    report: "Laporkan",
    report_confirm: "Apakah Anda yakin komentar ini melanggar pedoman komunitas?",
    report_success: "Terima kasih telah melaporkan,\nlaporan Anda sedang ditinjau",
  },
  bottom_navigation: "Komunitas",
  shared_post: "Telah membagikan postingan"
};
